import { z } from 'zod';

export const FilterMappingTypeEnum = z.enum([
  'activity_entity',
  'platform_entity',
  'media_row_entity',
  'campaign_entity',
]);

export const FilterMappingStatusEnum = z.enum([
  'active',
  'inactive',
  'archived',
]);

export const DevicePlatformEnum = z.enum(['ios', 'android']);

export const FilterMappingExtraSchema = z.object({
  // Appsflyer specific fields
  appsflyerDevicePlatform: DevicePlatformEnum.nullish(),

  // Adform specific fields
  adformExternalUuid: z.string().nullish(),
  adformCampaignId: z.string().nullish(),

  // Campaign Manager specific fields
  campaignManagerAdvertiserId: z.string().nullish(),
});

export const FilterMappingSchema = z.object({
  id: z.string(),
  settingsId: z.string(),
  name: z.string(),
  externalId: z.string(),
  type: FilterMappingTypeEnum,
  status: FilterMappingStatusEnum,
  taxonomyItemId: z.string(),
  parentIds: z.array(z.string()).nullish(),
  extra: FilterMappingExtraSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
